<template>
    <el-card class="box-card" sytle="padding: 5px;">
        <!-- 表单只有一个文本框的时候，按回车会自动submit表单，需要禁用sunmit -->
        <el-form
            ref="searchform"
            :inline="true"
            :model="form"
            @submit.native.prevent
            size="medium"
        >
            <el-form-item  label="状态" prop="state">
                <el-select
                    v-model="form.state"
                    filterable
                    clearable
                    placeholder=""
                >
                    <el-option
                        v-for="(v,i) in ['待审核','正常','已禁用']"
                        :key="i"
                        :label="v"
                        :value="i"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="昵称" prop="name">
                <el-input
                    v-model="form.name"
                    placeholder="昵称搜索"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="username">
                <el-input
                    v-model="form.username"
                    placeholder="用户名搜索"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item  label="权限组" prop="auth_team_id">
                <el-select
                    v-model="form.auth_team_id"
                    filterable
                    clearable
                    placeholder="所属权限组"
                    class="auth_team_id"
                >
                    <el-option
                        v-for="item in AllAuthTeam"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="search">搜索</el-button>
                <el-button type="warning" plain @click="resetbtn('searchform')"
                    >重置</el-button
                >
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
export default {
    name: 'UserSearchBarComponent',
    data() {
        return {
            fdialogFormVisible: false,
            form: {
                state: '',
                username: '',
                name: '',
                auth_team_id: '',
                page: 1
            },
        }
    },
    computed: {},
    methods: {
        search() {
            this.$emit('search', this.form)
        },
        resetbtn(f) {
            this.$refs[f].resetFields()
        }
    },
    filters: {},
    props: {
        AllAuthTeam: {
            type: Array,
            default() {
                return []
            }
        }
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {},
}
</script>

<style lang='less' scoped>
.box-card .el-form-item {
    margin-bottom: 3px;
}
</style>